import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography,
  Button,
  Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TableComponents, Icons } from 'components';
import { useCopy } from 'hooks';
import { Alert } from '@mui/material';
import Services from '../../../services/Services';
import { columns, generateData } from './Columns';
import { PaymentWithCreditDialog } from '../index';
import { PerSettlementDialog } from '../index';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';

const LoanInstallmentDialog = ({ open, setOpen, loan }) => {
  const classes = useStyles();
  const { copyItem } = useCopy();
  const [loading, setLoading] = useState(false);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [paymentWithCreditOpen, setPaymentWithCreditOpen] = useState(false);
  const [perSettlementOpen, setPerSettlementOpen] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const dialogTableRef = useRef();
  /**
        * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
        */
  const actionsList =
    getDynamicObjectAction([
      'invoiceFinancingPayInDgAction',
      'invoiceFinancingPaySoonerInDgAction',
    ]);

  useEffect(() => {
    if (!open) return;
  }, []);
  
  const getLoanInstallmentList = async (query) => {
    setLoading(true);
    try {
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        loanId: loan?.loanId,
      };
      const res = await Services.getUserInstallmentList(params);

      let list = [];

      if (res?.result) {
        for (const item of res?.result) {
          item['loadnId'] = loan?.loanId;
        }
        list = generateData(res?.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count || 0,
      };
      setLoading(false);
      return d;
    } catch (e) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  return (
    <>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="md"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.title}
        >
          لیست اقساط
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            size="large">
            <Icons icon='Close' color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Alert
            severity="info"
            icon={null}
            className={classes.alert}
            style={{ alignItems: 'center', marginBottom: '1em' }}
          >
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              style={{ width: '100%' }}
            >
              <Grid item md={10} xs={12}>
                <Typography>
                  شناسه واریز: {loan?.paymentNumber ?? 'بدون شناسه واریز'}{' '}
                  {loan?.paymentNumber && (
                    <IconButton onClick={() => copyItem(loan?.paymentNumber)} size="large">
                      <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                    </IconButton>
                  )}
                </Typography>
              </Grid>
              {
                actionsList['invoiceFinancingPaySoonerInDgAction'] &&
                <Grid item md={2} xs={12} container justifyContent="flex-end">
                  <Button
                    onClick={() => setPerSettlementOpen(true)}
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={loan?.statusCode !== 'LOAN_STATUS_CREATED'}
                  >
                    تسویه زودتر از موعد
                  </Button>
                </Grid>
              }

            </Grid>
          </Alert>

          <TableComponents
            data={getLoanInstallmentList}
            columns={columns}
            isLoading={loading}
            ref={dialogTableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber);
              setSize(ps?.pageSize);
              return getLoanInstallmentList(ps);
            }}
            actions={actionsList['invoiceFinancingPayInDgAction'] ? [
              (rd) => {
                return {
                  icon: () => (
                    <Button
                      disabled={rd.status != 'INSTALLMENT_STATUS_CREATED'}
                      startIcon={<Icons icon='Banking' color="#939393" size="20" />}
                      variant="contained"
                      className={classes.expandBtn}
                      onClick={() => {
                        setPaymentWithCreditOpen(true);
                        setSelectedInstallment(rd);
                      }}
                    >
                      پرداخت
                    </Button>
                  ),
                };
              },
            ] : []}
          />
        </DialogContent>
        <PaymentWithCreditDialog
          open={paymentWithCreditOpen}
          setOpen={setPaymentWithCreditOpen}
          installment={selectedInstallment}
          tableRef={dialogTableRef}
        />
        <PerSettlementDialog
          open={perSettlementOpen}
          setOpen={setPerSettlementOpen}
          loan={loan}
          tableRef={dialogTableRef}
        />
      </Dialog>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  alert: {
    '& .MuiAlert-root': {
      display: 'flex',
      alignItems: 'center !important',
      marginBottom: '1em',
    },
    '& .MuiAlert-message': {
      width: '100%',
    },
  },
}));

export default LoanInstallmentDialog;
